(function () {
  const ROOT_SELECTOR = '[data-challenge-menu-root]';

  const initRoot = (root) => {
    if (!root || root.dataset.initialized === 'true') return;

    const triggers = Array.from(root.querySelectorAll('[data-menu-trigger]'));
    const panels = Array.from(root.querySelectorAll('[data-menu-panel]'));

    if (!triggers.length) return;

    root.dataset.initialized = 'true';

    const params = new URLSearchParams(window.location.search);
    const defaultMenu = root.dataset.defaultMenu === 'vegetal' ? 'vegetal' : 'omnivore';
    const initialMenu = params.get('menu_type') === 'vegetal' ? 'vegetal' : defaultMenu;

    const syncMenuTypeParam = (menuType) => {
      const nextUrl = new URL(window.location.href);

      if (menuType === 'vegetal') {
        nextUrl.searchParams.set('menu_type', 'vegetal');
      } else {
        nextUrl.searchParams.delete('menu_type');
      }

      window.history.replaceState({}, '', nextUrl.toString());
    };

    const setActiveMenu = (menuType) => {
      triggers.forEach((trigger) => {
        const isActive = trigger.dataset.menuTrigger === menuType;

        trigger.classList.toggle('is-active', isActive);
        if (trigger.getAttribute('role') == 'tab') {
          trigger.setAttribute('aria-selected', isActive ? 'true' : 'false');
        }
        if (trigger.hasAttribute('aria-pressed')) {
          trigger.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        }
      });

      if (panels.length) {
        panels.forEach((panel) => {
          panel.hidden = panel.dataset.menuPanel !== menuType;
        });
      }

      root.querySelectorAll('[data-menu-link-switch]').forEach((link) => {
        const nextHref =
          menuType === 'vegetal' ? link.dataset.menuLinkVegetal || link.dataset.menuLink : link.dataset.menuLink;

        if (nextHref) link.setAttribute('href', nextHref);
      });
    };

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const selectedMenu = trigger.dataset.menuTrigger;

        setActiveMenu(selectedMenu);
        syncMenuTypeParam(selectedMenu);
      });
    });

    setActiveMenu(initialMenu);
  };

  const initAll = (container = document) => {
    container.querySelectorAll(ROOT_SELECTOR).forEach(initRoot);
  };

  if (window.ChallengeMenuToggle) {
    window.ChallengeMenuToggle.initAll();
    return;
  }

  window.ChallengeMenuToggle = {
    initAll,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
